module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SK-454d024b5d0818e9c53438ba29ee0566.png";